<style lang="css">
@import '../css/bootstrap.css';
@import '../css/bootstrap-vue.css';
@import '../css/admin-table.css';
</style>
<style lang="scss" scoped>
@import '../css/admin.scss';
</style>
<template>
  <div class="admin-page">
    <admin-header :tit="this.title"></admin-header>
    <admin-side></admin-side>
    <section class="admin-template">
      <h2 class="sub-tit">서식자료 관리</h2>
      <div class="contents">
        <b-container fluid>
          <!-- User Interface controls -->
            <b-row>
             <b-col class="my-1 text-left type-box">
               <b-form-group
                label="사용여부"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" v-model="itemSelected" :options="itemOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="my-1 text-left type-box">
               <b-form-group
                label="서식타입"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" v-model="typeSelected" :options="typeOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="my-1 filter-box notice-search-area">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    type="search"
                    placeholder="서식자료 제목을 입력해 주세요."
                    v-model="searchText"
                  ></b-form-input>
                  <b-button size="sm" @click="itemFilter()" class="search-btn">검색</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            id="expert-management"
            :items="items"
            :fields="fields"
            stacked="md"
            show-empty
            small
          >
            <template #cell(useYn)="row">
              {{ row.value }}
            </template>
            <template #cell(docId)="row">
              {{ row.value }}
            </template>
            <template #cell(CodeNm)="row">
              {{ row.value }}
            </template>
            <template #cell(itemNm)="row">
              {{ row.value }}
            </template>
            <template #cell(itemPrice)="row">
              {{ row.value }}
            </template>
            <template #cell(docTitle)="row">
              {{ row.value }}
            </template>
            <template #cell(actions)="row">
              <b-button size="sm" @click="modifyWrite(row.item, row.index)" class="save-btn mr-1">수정</b-button>
              <b-button size="sm" @click="deleteItem(row.item, row.index)" class="deleat-btn">삭제</b-button>
            </template>
          </b-table>
          <b-row>
            <b-col lg="12" class="my-1 text-right">
              <b-button variant="primary" class="new-item-btn" @click="newWrite()">등록</b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-modal
          id="reference-new-write"
          class="item-modal"
          size="lg"
          title="서식자료 등록하기"
          @show="resetModal"
          @hidden="resetModal"
          >
            <b-row class="modal-top-row">
              <b-col sm="7" class="my-1 modal-top-area">
                <div class="my-1 text-left modal-top-left">
                  <label>서식 번호</label>
                  <b-form-input
                    v-model="documentModal.selectNum"
                    disabled
                  ></b-form-input>
                </div>
                <div class="my-1 text-left modal-top-center">
                  <label>사용여부</label>
                  <b-form-select size="sm" class="item-select" v-model="documentModal.whetherSelected" :options="documentModal.whether"></b-form-select>
               </div>
              </b-col>
              <b-col sm="5" class="my-1">
                <div class="my-1 modal-top-right">
                  <label>서식 타입</label>
                  <b-form-select size="sm" class="item-select" v-model="documentModal.typeSelected" :options="documentModal.type" @change="onChange($event)"></b-form-select>
                </div>
              </b-col>
              <b-col class="my-1 text-left type-box footer-command-box" sm="6" v-if="documentModal.choiceArea">
                <label>상품 선택</label>
                <b-form-select size="sm" class="item-select" v-model="documentModal.choiceSelected" :options="documentModal.choice" @change="itemOnChange($event)"></b-form-select>
              </b-col>
              <b-col class="my-1 text-left type-box footer-command-box" sm="6" v-if="documentModal.choiceArea">
                <label>상품 가격</label>
                  <b-form-input
                    v-model="documentModal.choicePrice"
                    disabled
                  ></b-form-input>
              </b-col>
              <b-col class="my-1 text-left type-box footer-command-box" sm="12">
                <label>서식 제목</label>
                <b-form-input class="footer-command" v-model="documentModal.titleDocument"></b-form-input>
              </b-col>
            </b-row>
          <template #modal-footer class="modify-footer-area">
            <quill-editor
            ref="newWriteEditor"
            v-model="documentModal.editorContent"
            :options="documentModal.editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
          />
          <div class="my-1 text-left desc search">
            <label>파일첨부</label>
            <VueFileAgent
            ref="vueFileAgent"
            :theme="'list'"
            :multiple="false"
            :deletable="true"
            :meta="true"
            :accept="'image/*,.pdf,.pptx,.docx,.hwp,.zip,.ppt,.doc'"
            :maxSize="'10MB'"
            :maxFiles="1"
            :helpText="'첨부할 사진을 마우스로 끌어서 추가할 수 있습니다.'"
            :errorText="{
              type: '이미지만 업로드가 가능합니다.',
              size: '사진크기는 10MB 를 넘을 수 없습니다.',
            }"
            @select="filesSelected($event)"
            @beforedelete="onBeforeDelete($event)"
            @delete="fileDeleted($event)"
            v-model="fileRecords"
            ></VueFileAgent>
              <div class="text-right save-btn-area">
                <b-button
                variant="primary"
                class="default-btn address-search btn-primary reference-btn"
                @click="writeSave()"
              >
                등록
              </b-button>
              </div>
            </div>
          </template>
        </b-modal>
        <b-modal
          id="reference-modify-write"
          class="item-modal"
          size="lg"
          title="서식자료 수정하기"
          @show="resetModal"
          @hidden="resetModal"
          >
            <b-row class="modal-top-row">
              <b-col sm="7" class="my-1 modal-top-area">
                <div class="my-1 text-left modal-top-left">
                  <label>서식 번호</label>
                  <b-form-input
                    v-model="documentModal.selectNum"
                    disabled
                  ></b-form-input>
                </div>
                <div class="my-1 text-left modal-top-center">
                  <label>사용여부</label>
                  <b-form-select size="sm" class="item-select" v-model="documentModal.whetherSelected" :options="documentModal.whether"></b-form-select>
               </div>
              </b-col>
              <b-col sm="5" class="my-1">
                <div class="my-1 modal-top-right">
                  <label>서식 타입</label>
                  <b-form-select size="sm" class="item-select" v-model="documentModal.typeSelected" :options="documentModal.type" @change="onChange($event)"></b-form-select>
                </div>
              </b-col>
              <b-col class="my-1 text-left type-box footer-command-box" sm="6" v-if="documentModal.choiceArea">
                <label>상품 선택</label>
                <b-form-select size="sm" class="item-select" v-model="documentModal.choiceSelected" :options="documentModal.choice" @change="itemOnChange($event)"></b-form-select>
              </b-col>
              <b-col class="my-1 text-left type-box footer-command-box" sm="6" v-if="documentModal.choiceArea">
                <label>상품 가격</label>
                  <b-form-input
                    v-model="documentModal.choicePrice"
                    disabled
                  ></b-form-input>
              </b-col>
              <b-col class="my-1 text-left type-box footer-command-box" sm="12">
                <label>서식 제목</label>
                <b-form-input class="footer-command" v-model="documentModal.titleDocument"></b-form-input>
              </b-col>
            </b-row>
          <template #modal-footer class="modify-footer-area">
            <quill-editor
            ref="modifyWriteEditor"
            v-model="documentModal.editorContent"
            :options="documentModal.editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
          />
          <div class="my-1 text-left desc search">
            <label>파일첨부</label>
            <VueFileAgent
            ref="vueFileAgent"
            :theme="'list'"
            :multiple="false"
            :deletable="true"
            :meta="true"
            :accept="'image/*,.pdf,.pptx,.docx,.hwp,.zip,.ppt,.doc'"
            :maxSize="'10MB'"
            :maxFiles="1"
            :helpText="'첨부할 사진을 마우스로 끌어서 추가할 수 있습니다.'"
            :errorText="{
              type: '이미지만 업로드가 가능합니다.',
              size: '사진크기는 10MB 를 넘을 수 없습니다.',
            }"
            @select="filesSelected($event)"
            @beforedelete="onBeforeDelete($event)"
            @delete="fileDeleted($event)"
            v-model="fileRecords"
            ></VueFileAgent>
            <div class="text-right save-btn-area">
              <b-button
              variant="primary"
              class="default-btn address-search btn-primary reference-btn"
              @click="modifySave()"
            >
              저장
            </b-button>
            </div>
          </div>
          </template>
        </b-modal>
    </section>
  </div>
</template>
<script>
import AdminHeader from '@/components/AdminHeader'
import AdminSide from '@/components/AdminSide'

import { mapGetters } from 'vuex'

export default {
  name: 'AdminReference',
  components: {
    'admin-header': AdminHeader,
    'admin-side': AdminSide
  },
  data () {
    return {
      title: '관리자 페이지',
      layerPopPost: false,
      itemSelected: '',
      typeSelected: '0',
      addressCitySelected: '0',
      itemOptions: [
        { value: '', text: '전체' },
        { value: 'Y', text: '사용' },
        { value: 'N', text: '미사용' }
      ],
      typeOptions: [
        { value: '', text: '전체' }
      ],
      searchText: '',
      /* items: [
        { status: '사용', number: '1', type: '무료', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', item: '부동산법개정안', price: '5000' },
        { status: '사용', number: '2', type: '무료', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', item: '땡처리양식', price: '5000' },
        { status: '사용', number: '3', type: '무료', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', item: '땡처리양식', price: '5000' },
        { status: '사용', number: '4', type: '유료', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', item: '땡처리양식', price: '5000' },
        { status: '사용', number: '5', type: '무료', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', item: '매물양식', price: '5000' },
        { status: '사용', number: '6', type: '무료', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', item: '매물양식', price: '5000' },
        { status: '사용', number: '7', type: '무료', tit: '안심매물관리규정 및 관련 정책개정안내(2019.11.12)', item: '매물양식', price: '5000' }
      ], */
      fields: [
        { key: 'useYn', label: '사용 여부', class: 'text-center' },
        { key: 'docId', label: '서식 번호', class: 'text-center' },
        { key: 'CodeNm', label: '서식 타입', class: 'text-center' },
        { key: 'itemNm', label: '상품명', class: 'text-center' },
        { key: 'itemPrice', label: '상품가격', class: 'text-center' },
        { key: 'docTitle', label: '서식 제목', class: 'text-center' },
        { key: 'actions', label: '', class: 'text-center' }
      ],
      documentModal: {
        title: '서식자료',
        selectNum: '01',
        choicePrice: '0',
        whetherSelected: 'Y',
        typeSelected: '0',
        choiceSelected: '0',
        choiceArea: false,
        titleDocument: '',
        editorContent: '<h2>내용 입력</h2>',
        editorOption: {
          // Some Quill options...
        },
        whether: [
          { value: 'Y', text: '사용' },
          { value: 'N', text: '미사용' }
        ],
        type: [
          { value: '0', text: '무료' },
          { value: '1', text: '유료' }
        ],
        choice: [
          { value: '0', text: '1번 자료' },
          { value: '1', text: '2번 자료' }
        ]
      },
      newEditorContent: '<h2>내용 입력</h2>',
      newEditorOption: {
        // Some Quill options...
      },
      modifyEditorContent: '<h2>수정내용 입력</h2>',
      modifyEditorOption: {
        // Some Quill options...
      },
      addFileRecords: [],
      modifyFileRecords: [],
      fileRecordsForUpload: [],
      fileRecordsForDelete: [],
      fileRecords: [
        /* {
          name: 'img_start.png',
          url: 'http://127.0.0.1:8081/uploads/pro_images/7/img_start.png',
          lastModified: '',
          size: '10000',
          type: 'image/png',
          ext: 'png',
        } */
      ],
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent' },
      imgUrl: this.$store.state.common.urlpath,
      uploadUrl: this.$store.state.common.urlpath + '/api/fileupload/process'
      // uploadUrl: 'http://127.0.0.1:8081' + '/api/fileupload/process'
    }
  },
  created () {
    this.initDocumentCode()
  },
  watch: {
    typeDocument () {
      this.documentModal.type = []
      for (var i = 0; i < this.typeDocument.length; i++) {
        // console.log(this.typeNotices[i])
        let tmp = { value: this.typeDocument[i].deCode, text: this.typeDocument[i].codeNm }
        this.typeOptions.push(tmp)
        this.documentModal.type.push(tmp)
      }
      this.typeSelected = this.typeOptions[0].value
      this.documentModal.typeSelected = this.documentModal.type[0].value
      // this.searchNotice()
      this.initItemList()
      this.getDocumentList()
    },
    itemInfoList () {
      this.documentModal.choice = []
      for (var i = 0; i < this.itemInfoList.length; i++) {
        // console.log(this.typeNotices[i])
        // let tmp = { value: this.itemInfoList[i].itemCd, text: this.itemInfoList[i].itemNm, price: this.itemInfoList[i].itemPrice }
        let tmp = { value: this.itemInfoList[i], text: this.itemInfoList[i].itemNm }
        this.documentModal.choice.push(tmp)
      }
      this.documentModal.choiceSelected = this.documentModal.choice[0].value
      this.documentModal.choicePrice = this.documentModal.choice[0].value.itemPrice
    }
  },
  methods: {
    initDocumentCode () {
      this.$store.dispatch('apiEtcCodelists', {'Code': '004', 'DeCode': ''})
    },
    initItemList () {
      this.$store.dispatch('apiItemInfoists', {'itemType': '002', 'itemCd': ''})
    },
    getDocumentList () {
      this.$store.dispatch('apiDocumentList', {'useYn': this.itemSelected, 'docCd': this.typeSelected, 'docTitle': this.searchText})
    },
    findSelectType (typeValue) {
      if (typeValue === '') {
        return ''
      }
      for (var i = 0; i < this.documentModal.type.length; i++) {
        if (this.documentModal.type[i].value === typeValue) {
          return ''
        }
      }
    },
    findSelectItem (itemCode) {
      if (itemCode === '') {
        return ''
      }
      for (var i = 0; i < this.documentModal.choice.length; i++) {
        if (this.documentModal.choice[i].value.itemCd === itemCode) {
          return this.documentModal.choice[i].value
        }
      }
    },
    tranSaveVaild () {
      if (this.documentModal.titleDocument === '') {
        return '서식 제목을 입력하세요.'
      }
      if (this.documentModal.editorContent === '') {
        return '서식 내용을 입력하세요.'
      }
      if (this.fileRecords.length === 0) {
        return '서식 첨부파일이 없습니다.'
      }
      return 'success'
    },
    saveDocument (type, obj) {
      const params = {
        'clDoc': obj.typeSelected,
        'itemCd': (obj.typeSelected === '001' ? '' : obj.choiceSelected.itemCd),
        'docTitle': obj.titleDocument,
        'docContent': obj.editorContent,
        'useYn': obj.whetherSelected,
        'userId': 'admin',
        'docId': (obj.selectNum === '신규' ? '' : obj.selectNum),
        'flag': type
      }
      // console.log('param = ' + params)
      this.$store.dispatch('apiTranDocument', params).then(() => {
        // console.log('this.tranDocumentRtn = ' + this.tranDocumentRtn.docId)
        if (this.tranDocumentRtn.docId !== 'fail') {
          if (type === 'I') {
            // alert('저장')
            this.uploadFiles()
            this.$nextTick(() => {
              this.$bvModal.hide('reference-new-write')
            })
          } else if (type === 'U') {
            if (this.fileRecordsForDelete.length > 0) {
              this.deleteUploadedFile()
            } else {
              this.uploadFiles()
            }
            // alert('수정완료')
            this.$nextTick(() => {
              this.$bvModal.hide('reference-modify-write')
            })
          } else {
            // alert('삭제')
            if (this.fileRecordsForDelete.length > 0) {
              this.deleteUploadedFile()
            } else {
              // console.log('this.setProlist == 1')
              this.getDocumentList()
            }
          }
        } else {
          alert('내용 저장에 실패하였습니다.')
        }
      })
    },
    getFileInfo (item) {
      let obj = []
      if (item.fileName === '') {
        return obj
      } else {
        let fileArr = item.fileName.split('/')
        let file = {
          name: fileArr[fileArr.length - 1],
          file: { name: fileArr[fileArr.length - 1] },
          url: this.imgUrl + '/' + item.fileName,
          lastModified: item.fileLast,
          size: item.fileSize,
          type: item.fileType,
          ext: item.fileExt
        }
        obj.push(file)
        return obj
      }
    },
    newWrite () {
      this.documentModal.title = '서식자료 등록하기'
      this.documentModal.selectNum = '신규'
      this.documentModal.typeSelected = this.documentModal.type[0].value
      this.documentModal.choiceArea = false
      this.documentModal.choiceSelected = this.documentModal.choice[0].value
      this.documentModal.choicePrice = this.documentModal.choice[0].value.itemPrice
      this.documentModal.whetherSelected = 'Y'
      this.documentModal.titleDocument = ''
      this.documentModal.editorContent = '<h2>내용 입력</h2>'
      this.fileRecords = []
      this.fileRecordsForUpload = []
      this.fileRecordsForDelete = []
      this.$root.$emit('bv::show::modal', 'reference-new-write')
    },
    modifyWrite (item, index) {
      this.documentModal.title = '서식자료 수정하기'
      if (item.itemCd === '') {
        this.documentModal.choiceArea = false
        this.documentModal.choiceSelected = this.documentModal.choice[0].value
        this.documentModal.choicePrice = this.documentModal.choice[0].value.itemPrice
      } else {
        this.documentModal.choiceArea = true
        this.documentModal.choiceSelected = this.findSelectItem(item.itemCd)
        this.documentModal.choicePrice = item.itemPrice
      }
      this.documentModal.selectNum = item.docId
      this.documentModal.typeSelected = item.docCd
      this.documentModal.whetherSelected = (item.useYn === '사용' ? 'Y' : 'N')
      this.documentModal.titleDocument = item.docTitle
      this.documentModal.editorContent = item.docContent
      let info = this.getFileInfo(item)
      this.fileRecords = info
      this.fileRecordsForUpload = info
      this.fileRecordsForDelete = []
      this.$root.$emit('bv::show::modal', 'reference-modify-write')
    },
    writeSave () {
      let str = this.tranSaveVaild()
      if (str === 'success') {
        this.saveDocument('I', this.documentModal)
      } else {
        alert(str)
      }
    },
    modifySave () {
      let str = this.tranSaveVaild()
      if (str === 'success') {
        this.saveDocument('U', this.documentModal)
      } else {
        alert(str)
      }
    },
    itemFilter () {
      // alert('itemFilter')
      this.getDocumentList()
    },
    deleteItem (item, index) {
      // console.log(item)
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        const params = {
          'selectNum': item.docId,
          'typeSelected': item.docCd,
          'whetherSelected': (item.useYn === '사용' ? 'Y' : 'N'),
          'titleDocument': item.docTitle,
          'editorContent': item.docContent,
          'choiceSelected': ''
        }
        this.fileRecordsForUpload = []
        this.fileRecordsForDelete = this.getFileInfo(item)
        this.saveDocument('D', params)
      } else {
        return false
      }
    },
    resetModal () {
      /* this.documentModal.whetherSelected = '0'
      this.documentModal.typeSelected = '0'
      this.documentModal.choiceSelected = '0'
      this.documentModal.choiceArea = false */
      // alert('resetModal')
    },
    onChange (event) {
      if (event === '002') {
        this.documentModal.choiceArea = true
      } else {
        this.documentModal.choiceArea = false
        this.documentModal.choiceSelected = this.documentModal.choice[0].value
        this.documentModal.choicePrice = this.documentModal.choice[0].value.itemPrice
      }
    },
    itemOnChange (event) {
      // 여기부터 다시 시작
      this.documentModal.choicePrice = event.itemPrice
    },
    onEditorBlur (quill) {
      // console.log('editor blur!', quill)
    },
    onEditorFocus (quill) {
      // console.log('editor focus!', quill)
    },
    onEditorReady (quill) {
      // console.log('editor ready!', quill)
    },
    onKeyUp (quill) {
      // alert('keyup')
    },
    filesSelected: function (fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error)
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords)
      if (this.fileRecordsForUpload.length > 1) {
        var tmpFileRecord = this.fileRecordsForUpload[0]
        // console.log('filesSelected fileRecords tmp=' + JSON.stringify(tmpFileRecord))
        this.onBeforeDelete(tmpFileRecord)
      }
      // console.log('filesSelected fileRecords =' + JSON.stringify(this.fileRecords))
      // console.log('filesSelected fileRecordsForUpload =' + JSON.stringify(this.fileRecordsForUpload))
    },
    fileDeleted: function (fileRecord) {
      // console.log('fileDeleted = ' + JSON.stringify(fileRecord))
      var i = this.fileRecordsForUpload.indexOf(fileRecord)
      // console.log('fileDeleted i = ' + i)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      }
      /* else {
        this.deleteUploadedFile(fileRecord)
      } */
    },
    deleteUploadedFile: function () {
      // console.log('deleteUploadedFile = ' + JSON.stringify(this.fileRecordsForDelete))
      const params = {
        'deleteFiles': this.fileRecordsForDelete,
        'gubun': '02',
        'idDtFile': this.tranDocumentRtn.docId
      }
      this.$store.dispatch('apiDeleteFiles', params).then(() => {
        if (this.deleteFilesRtn !== 'ok') {
          alert('file을 삭제 중 이상이 발생하였습니다.')
        } else {
          this.uploadFiles()
        }
      })
    },
    onBeforeDelete: function (fileRecord) {
      // fileRecord.name = fileRecord.file.name
      // console.log('onBeforeDelete = ' + JSON.stringify(fileRecord))
      // console.log('onBeforeDelete = ' + JSON.stringify(this.fileRecordsForUpload))
      var i = this.fileRecordsForUpload.indexOf(fileRecord)
      // console.log('onBeforeDelete = ' + i)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
        var k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
        // console.log(JSON.stringify(fileRecord))
        // console.log(JSON.stringify(fileRecord.url))
        let idx = JSON.stringify(fileRecord).indexOf(this.imgUrl)
        if (idx !== -1) {
          this.fileRecordsForDelete.push(fileRecord)
        }
      } else {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord)
      }
    },
    uploadFiles: function () {
      // console.log('uploadFiles = ' + this.fileRecordsForUpload.length)
      let tranDocumentRtn = this.tranDocumentRtn.docId
      // console.log('tranDocumentRtn = ' + tranDocumentRtn)
      if (this.fileRecordsForUpload.length > 0) {
        // console.log('uploadFiles = ' + JSON.stringify(this.fileRecordsForUpload))
        this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload, function createFormData (fileData) {
          var formData = new FormData()
          formData.append('id', tranDocumentRtn)
          formData.append('type', '02')
          formData.append('file', fileData.file)
          return formData
        }).then(response => {
          // console.log('response = ' + response.state)
          // console.log('uploadFiles = 22')
          this.fileDataUpload()
        })
        // console.log('uploadFiles = 11')
      } else {
        const params = {
          'Gubun': '02',
          'idAtFile': this.tranDocumentRtn.docId,
          'flag': 'DELETE'
        }
        // console.log(params)
        this.$store.dispatch('apiAttachedFiles', params).then(() => {
          if (this.fileFlag === 'ok') {
            this.fileRecordsForUpload = []
            this.fileRecordsForDelete = []
            this.fileRecords = []
            // console.log('this.getDocumentList == 2')
            this.getDocumentList()
          }
        })
      }
    },
    fileDataUpload () {
      /* console.log('onUpload = ' + JSON.stringify(this.fileRecordsForUpload))
      console.log('type = ' + this.fileRecordsForUpload[0].type)
      console.log('size = ' + this.fileRecordsForUpload[0].size)
      console.log('ext = ' + this.fileRecordsForUpload[0].ext)
      console.log('lastModified = ' + this.fileRecordsForUpload[0].lastModified)
      console.log('lastModified = ' + this.fileRecordsForUpload[0].file.name) */
      this.AtFile = []
      this.AtFile.push({'nameAtFile': this.fileRecordsForUpload[0].file.name, 'ordAtFile': 0, 'fileType': this.fileRecordsForUpload[0].type, 'fileSize': this.fileRecordsForUpload[0].size, 'fileExt': this.fileRecordsForUpload[0].ext, 'fileMody': this.fileRecordsForUpload[0].lastModified})
      const params = {
        'Gubun': '02',
        'idAtFile': this.tranDocumentRtn.docId,
        'AtFile': this.AtFile,
        'flag': 'INSERT'
      }
      // console.log(params)
      this.$store.dispatch('apiAttachedFiles', params).then(() => {
        if (this.fileFlag === 'ok') {
          this.fileRecordsForUpload = []
          this.fileRecordsForDelete = []
          this.fileRecords = []
          // console.log('this.getDocumentList == 3')
          this.getDocumentList()
        }
      })
    },
    onUpload (responses) {
      // console.log('onUpload = ' + JSON.stringify(responses))
    },
    onUploadError (failedResponses) {
      alert('file 업로드 중 이상이 발생하였습니다.')
      // console.log('ERROR : ', failedResponses)
    }
  },
  computed: {
    ...mapGetters({
      typeDocument: 'getEtcCodeList',
      itemInfoList: 'getItemInfoList',
      items: 'getDocumentList',
      tranDocumentRtn: 'getTranDocument',
      deleteFilesRtn: 'getDeleteFiles',
      fileFlag: 'getAttachedFlag'
    })
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/AdminReference.vue